import ReactCanvasNest from "react-canvas-nest";
import { useTranslation } from "react-i18next";

function Home() {
  const { t } = useTranslation();
  return (
    <div className="h-full w-full">
      <ReactCanvasNest config={{ pointColor: "168,85,247", lineColor: "168,85,247", follow: true, pointR: 2 }} style={{ zIndex: 0 }} className="home-canvas" />
      <div className="content-list">
        <div className={"post"}>
          <div className="post-content">
            <h2 className="post-title">Abdellah OUMAS</h2>
            <p className="post-text">{t("web_dev")}</p>
            <p className="post-text">{t("welcome")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
